import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createActionSetErrorVisible } from '../actions/errorActions';
import { navigateToWithPageRefresh } from '../../libs/history';
import { Button } from '../../components/presentational/buttons/Button';
import { Stack } from '../../components/stack/Stack';
import Modal from '../../components/modal/modal';
import { TErrorState } from './types';
import { FC } from 'react';

export type TErrorContainerProps = {
  hideHandler?: () => void;
  type?: 'close' | 'reload';
};

const ErrorContainer: FC<TErrorContainerProps> = ({ hideHandler, type: propType }) => {
  const dispatch = useDispatch();
  const {
    visible,
    title,
    body,
    overlayStyles,
    bodyStyles,
    type: stateType
  } = useSelector((state: TErrorState) => state.error);

  const type = propType || stateType;

  if (!visible) {
    return <span />;
  }

  const doClose = () => {
    if (hideHandler) {
      hideHandler();
    }
    dispatch(createActionSetErrorVisible(false));
  };

  const doReload = () => {
    window.location.reload();
  };

  const doReturnHome = () => {
    navigateToWithPageRefresh('/');
  };

  const renderButtons = () => {
    if (type === 'close') {
      return (
        <Button variant="default" onClick={doClose}>
          {t('common:terms.close')}
        </Button>
      );
    }
    return (
      <Stack justifyContent="space-between">
        <Button variant="default" onClick={doReload}>
          {t('common:terms.reload')}
        </Button>
        <Button variant="primary" onClick={doReturnHome}>
          {t('common:terms.home')}
        </Button>
      </Stack>
    );
  };

  return (
    <Modal
      isOpen={visible}
      onRequestClose={doClose}
      className="rio-modal--centered"
      classModalContent="raider-modal__content"
      title={title}
      overlayStyles={{ zIndex: 99999, ...overlayStyles }}
    >
      <div className="rio-modal__body slds-text-body--regular" style={bodyStyles}>
        {body}
      </div>
      <div className="rio-modal__footer rio-modal__footer--bordered rio-modal__footer--sm">{renderButtons()}</div>
    </Modal>
  );
};

export default ErrorContainer;
